// import { useState } from "react";
// import { ImageSkeleton } from "./Skeleton";

// export const LazyImage = ({ src, priority, alt = "Post image" }) => {
//   const [isLoaded, setIsLoaded] = useState(false);

//   return (
//     <div className="image-container">
//       {!isLoaded && <ImageSkeleton />}
//       <img
//         src={src}
//         alt={alt}
//         loading={priority ? "eager" : "lazy"}
//         decoding="async"
//         className={`social-image rounded-image ${isLoaded ? "loaded" : ""}`}
//         onLoad={() => setIsLoaded(true)}
//         onError={(e) => {
//           e.currentTarget.src = src.replace(/\?.*$/, "") + ".jpg";
//         }}
//         style={{
//           objectFit: "cover", // fills feed space, keeps aspect ratio
//           width: "100%", // full container width
//           height: "auto", // adjusts height automatically
//           maxWidth: "100%",
//           borderRadius: "12px", // consistent rounded edges
//         }}
//       />
//     </div>
//   );
// };
// LazyImage.jsx
import { useState } from "react";
import { ImageSkeleton } from "./Skeleton";
import "./LazyImage.css";
export const LazyImage = ({
  src,
  priority,
  alt = "Post image",
  edgeToEdge,
}) => {
  const [isLoaded, setIsLoaded] = useState(false);

  return (
    <div className="image-wrapper">
      {!isLoaded && <ImageSkeleton />}

      <img
        src={src}
        alt={alt}
        loading={priority ? "eager" : "lazy"}
        // decoding="async"
        decoding={priority ? "sync" : "async"}
        className={`social-image ${isLoaded ? "loaded" : ""}`}
        onLoad={() => requestAnimationFrame(() => setIsLoaded(true))}
        onError={(e) => {
          if (!e.currentTarget.dataset.fallback) {
            e.currentTarget.dataset.fallback = "true";
            e.currentTarget.src = src.replace(/\?.*$/, "") + ".jpg";
          }
        }}
        style={{
          objectFit: "cover", // fills feed space, keeps aspect ratio
          width: "100%", // full container width
          maxWidth: "100%",
          height: "auto", // adjusts height automatically
          // borderRadius: edgeToEdge ? "0" : "12px", // consistent rounded edges
        }}
      />
    </div>
  );
};
